var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 15.872c-1.832.453-3 1.139-3 1.907 0 1.364 3.694 2.471 8.25 2.471s8.25-1.107 8.25-2.471c0-.768-1.168-1.454-3-1.907M13.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm3.75-.188c0 3.188-3 6.938-5.25 8.438-2.25-1.5-5.25-5.25-5.25-8.438C6.75 6.018 9 3.75 12 3.75s5.25 2.267 5.25 5.063Z",
    stroke: "#5C7AFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgLocation;